// extracted by mini-css-extract-plugin
export default {"container":"FavoriteList_container__xe-js","cardGrid":"FavoriteList_cardGrid__Lr7J6","alert":"FavoriteList_alert__MZQQe"};